import React from 'react'
import './style.sass'

// Freccia orientata verso destra
const ArrowIcon = props => (
  <svg
    className={`ArrowIcon ${props.className || ''}`}
    stroke="#000"
    viewBox="0 0 50 50"
  >
    <line className="ArrowIcon__Line" x1={3} y1={25} x2={47} y2={25} />
    <line x1={47} y1={25} x2={25} y2={3} />
    <line x1={47} y1={25} x2={25} y2={47} />
  </svg>
)

export default ArrowIcon



// WEBPACK FOOTER //
// ./src/components/svgs/arrow-right/index.js